<div class="comecar">
  <div class="cm-aviso" *ngIf="carregando">Carregando…</div>

  <div class="cm-aviso cm-aviso--erro" *ngIf="!carregando && erro">
    {{ erro }} <button type="button" class="cm-link" (click)="carregue()">Tentar de novo</button>
  </div>

  <ng-container *ngIf="!carregando && !erro && estado">

    <!-- tela Pronto -->
    <app-tela-pronto *ngIf="passo === 'pronto'" [estado]="estado" [empresa]="empresa"></app-tela-pronto>

    <div class="cm-aviso" *ngIf="!estado.ativo && passo !== 'pronto'">
      Sua loja já passou pelos primeiros passos. <a class="cm-link" routerLink="/admin/index">Ir para o início</a>
    </div>

    <ng-container *ngIf="estado.ativo">
      <!-- um passo (o prêmio aparece no cabeçalho de cada um, pela moldura) -->
      <ng-container [ngSwitch]="passo" *ngIf="passo && passo !== 'pronto'">
        <app-passo-cardapio *ngSwitchCase="'cardapio'" [estado]="estado" (concluido)="aoConcluirPasso()" (ajuda)="pecaAjudaDe($event)"></app-passo-cardapio>
        <app-passo-loja *ngSwitchCase="'loja'" [estado]="estado" (concluido)="aoConcluirPasso($event)"></app-passo-loja>
        <app-passo-horarios *ngSwitchCase="'horarios'" [estado]="estado" (concluido)="aoConcluirPasso($event)"></app-passo-horarios>
        <app-passo-pagamento *ngSwitchCase="'pagamento'" [estado]="estado" (concluido)="aoConcluirPasso($event)"></app-passo-pagamento>
        <app-passo-receber *ngSwitchCase="'receber'" [estado]="estado" (concluido)="aoConcluirPasso($event)"
                           (atualizou)="atualize($event)" (ajuda)="pecaAjudaDe($event)"></app-passo-receber>
        <app-passo-teste *ngSwitchCase="'teste'" [estado]="estado" (concluido)="aoConcluirTeste($event)" (atualizou)="atualize($event)"></app-passo-teste>
      </ng-container>

      <!-- hub -->
      <ng-container *ngIf="!passo">
        <h4 class="page-title"><i class="fas fa-flag-checkered"></i> Primeiros passos</h4>

        <section class="cm-cabecalho">
          <p class="cm-sub">
            Sua loja <b>{{ empresa?.nome }}</b> já está no ar<ng-container *ngIf="linkCurto"> em <b>{{ linkCurto }}</b></ng-container>.
            <ng-container *ngIf="faltam > 0">Faltam <b>{{ faltam }} {{ faltam === 1 ? 'passo' : 'passos' }}</b> para você receber o primeiro pedido.</ng-container>
          </p>
          <div class="cm-progresso" role="progressbar" aria-label="Primeiros passos"
               aria-valuemin="0" [attr.aria-valuemax]="estado.total" [attr.aria-valuenow]="estado.feitos">
            <i *ngFor="let p of estado.passos" [class.feito]="p.feito" [class.proximo]="ehProximo(p)"></i>
          </div>
          <div class="cm-meta">
            <span>{{ estado.feitos }} de {{ estado.total }} feitos · uns {{ faltam * 2 }} minutos</span>
            <a *ngIf="empresa?.linkLoja" class="cm-ver-loja" [href]="empresa.linkLoja" target="_blank" rel="noopener">
              <i class="fas fa-external-link-alt"></i> Ver minha loja
            </a>
          </div>
          <div class="cm-continuar" *ngIf="proximo">
            <button type="button" class="onb-btn onb-btn--pri onb-btn--grande" (click)="continue()">
              Continuar: {{ proximo.nome }} <i class="fas fa-arrow-right"></i>
            </button>
          </div>
        </section>

        <app-onb-bonus class="cm-bonus" [estado]="estado" formato="destaque"></app-onb-bonus>

        <div class="onb-grupo-rot">Até o primeiro pedido</div>
        <div class="onb-grupo">
          <button type="button" class="cm-linha" *ngFor="let p of estado.passos" [class.proximo]="ehProximo(p)" (click)="abra(p)">
            <span class="onb-ic onb-ic--{{ p.id }}" [class.onb-ic--ok]="p.feito"><i [class]="icone(p)"></i></span>
            <span class="onb-tx"><b>{{ p.nome }}</b><span>{{ p.detalhe }}</span></span>
            <span class="onb-pill onb-pill--ok" *ngIf="p.feito">Feito</span>
            <span class="onb-pill onb-pill--acao" *ngIf="ehProximo(p)">Começar</span>
            <span class="onb-pill" *ngIf="!p.feito && !ehProximo(p)">{{ tempo(p) }}</span>
            <i class="fas fa-chevron-right cm-seta"></i>
          </button>
        </div>
        <p class="onb-nota">Pode fazer em qualquer ordem. O destacado é o que recomendamos agora. Parou no meio? A Mia te chama no WhatsApp com o link do passo que falta.</p>

        <ng-container *ngIf="fatosDaMia.length">
          <div class="onb-grupo-rot">O que a Mia já anotou na conversa</div>
          <div class="cm-mia">
            <span class="cm-mia-av">M</span>
            <div>
              <span>Isso já está considerado aqui. Você só confere.</span>
              <div class="cm-fatos"><span class="cm-fato" *ngFor="let f of fatosDaMia">{{ f.rotulo }} <b>{{ f.valor }}</b></span></div>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
  </ng-container>

  <app-onb-ajuda [passo]="passo || 'comecar'" [telefoneGestor]="estado?.telefoneGestor" [empresa]="empresa"></app-onb-ajuda>
</div>
